import { createContext, useContext } from 'react'
import {
  WithdrawMasterPayload,
  FolioDetail,
  WithdrawAccountDetail,
  TaxCalculationsResponse,
  OrderOtpState
} from '../../types/mf-execution.types'
import { OTPVerificationState, OTPVerificationHandlers } from '../../types/otp.types'
import { AmountAdjustmentReason } from '../../utils/mf-execution/paymentAmount'

interface WithdrawContextType {
  withdrawMasterPayload: WithdrawMasterPayload
  handleWithdrawMasterPayload: (payload: WithdrawMasterPayload) => void
  isWithdrawOTPVerified: boolean
  handleWithdrawOTPVerification: (otp: string) => void
  otpVerificationState: OTPVerificationState
  otpVerificationHandlers: OTPVerificationHandlers
  // Folio selection state
  selectedFolio: FolioDetail | null
  handleFolioSelection: (folio: FolioDetail | null) => void
  // Account selection state
  selectedAccount: WithdrawAccountDetail | null
  handleAccountSelection: (account: WithdrawAccountDetail | null) => void
  // Amount state
  amount: number
  /** Amount the screen opened with. Null when the field opened empty. */
  initialShownAmount: number | null
  handleAmountChange: (amount: number) => void
  fromAdvisory: boolean
  fromApp: boolean
  isFullWithdrawal: boolean
  amountAdjustmentReason: AmountAdjustmentReason
  clearAmountAdjustmentReason: () => void
  // Bank accounts
  bankAccounts: WithdrawAccountDetail[] | undefined
  /** True after this mount’s bank-accounts fetch finishes (avoids stale-cache CTA). */
  isBankAccountsFetchedAfterMount: boolean
  /** External/Infinite, or PowerUp after a successful empty bank-accounts GET. */
  withdrawsToFolioLinkedBank: boolean
  handleOTPTrigger: (payload: WithdrawMasterPayload) => void
  taxCalculations: TaxCalculationsResponse | null
  isTaxCalculationsLoading: boolean
  isTaxCalculationsError: boolean
  calculatedExitLoad: number
  handleRefetchTaxCalculations: () => Promise<any>
  otpState: OrderOtpState | null
}

export const WithdrawContext = createContext<WithdrawContextType | undefined>(undefined)

export const useWithdrawContext = () => {
  const context = useContext(WithdrawContext)
  if (!context) {
    throw new Error('useWithdrawContext must be used within a WithdrawProvider')
  }
  return context
}
